import ICONS from '../../lib/icons.js'
import { escapeHtml } from '../../lib/format.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-button ---
let __fez_component_0;
{
const PLAIN = ['href', 'target', 'rel', 'title', 'onclick', 'type', 'form', 'aria-label']
__fez_component_0 = class {
  NAME = (node) => (node.getAttribute('href') ? 'a' : 'button')

  PROPS = {
    label: String,
    icon: String,
    icon_right: String,
    variant: { type: String, default: 'secondary', enum: ['primary', 'secondary', 'ghost', 'danger', 'danger-ghost'] },
    size: { type: String, default: 'md', enum: ['sm', 'md', 'lg'] },
    loading: Boolean,
    disabled: Boolean,
    block: Boolean,
  }

  // No template: the root is the button and paint() is its only writer. A preserved button keeps
  // its element, so the parent's new props (onclick included) are re-applied in onRefresh.
  init() {
    this.state.baseClass = this.root.className
  }

  onRefresh(props, changed) {
    if (Object.keys(changed).length) this.paint()
  }

  paint() {
    const root = this.root
    const props = this.props
    const busy = Boolean(props.loading)
    const disabled = Boolean(props.disabled) || busy
    for (const name of PLAIN) {
      if (props[name] === undefined) root.removeAttribute(name)
    }
    this.copy(...PLAIN)
    if (root.tagName === 'BUTTON' && !props.type) root.setAttribute('type', 'button')
    if (disabled) {
      root.removeAttribute('onclick')
      root.removeAttribute('href')
    }
    if (root.tagName === 'BUTTON') root.disabled = disabled
    root.toggleAttribute('aria-disabled', disabled)
    root.toggleAttribute('aria-busy', busy)
    if (!props.label && props.title && !props['aria-label']) root.setAttribute('aria-label', props.title)

    const classes = [this.state.baseClass, props.variant, props.size]
    if (busy) classes.push('busy')
    if (props.block) classes.push('block')
    if (!props.label) classes.push('icon-only')
    root.className = classes.filter(Boolean).join(' ')

    const icon = (name) => (name && ICONS[name] ? `<span class="icon" aria-hidden="true">${ICONS[name]}</span>` : '')
    const label = props.label ? `<span class="label">${escapeHtml(props.label)}</span>` : ''
    const spinner = busy ? '<span class="spinner" aria-hidden="true"></span>' : ''
    root.innerHTML = `${busy ? spinner : icon(props.icon)}${label}${icon(props.icon_right)}`
  }

  CSS = `:fez {
display:inline-flex;align-items:center;justify-content:center;gap:var(--space-2);height:36px;padding:0 var(--space-4);border:1px solid transparent;border-radius:var(--radius-md);font-size:var(--text-sm);font-weight:var(--weight-semibold);line-height:1;white-space:nowrap;cursor:pointer;user-select:none;text-decoration:none;transition:background var(--duration-fast) var(--ease),border-color var(--duration-fast) var(--ease),color var(--duration-fast) var(--ease),box-shadow var(--duration-fast) var(--ease);&:hover{text-decoration:none}&:active:not([disabled]){transform:translateY(1px)}&[disabled],&[aria-disabled]{cursor:not-allowed;opacity:0.55}&.busy{cursor:progress;opacity:0.8}&.block{display:flex;width:100%}&.sm{height:28px;padding:0 var(--space-3);font-size:var(--text-xs);border-radius:var(--radius-sm)}&.lg{height:44px;padding:0 var(--space-6);font-size:var(--text-md)}&.icon-only{width:36px;padding:0;&.sm{width:28px}&.lg{width:44px}}&.primary{background:var(--color-accent);color:var(--color-accent-text);box-shadow:var(--shadow-sm);&:hover:not([disabled]){background:var(--color-accent-hover)}}&.secondary{background:var(--color-bg-raised);color:var(--color-text);border-color:var(--color-border-strong);box-shadow:var(--shadow-sm);&:hover:not([disabled]){background:var(--color-bg-hover)}}&.ghost{background:transparent;color:var(--color-text-muted);&:hover:not([disabled]){background:var(--color-bg-hover);color:var(--color-text)}}&.danger{background:var(--color-danger);color:var(--color-text-inverse);&:hover:not([disabled]){background:var(--color-danger-hover)}}&.danger-ghost{background:transparent;color:var(--color-danger);&:hover:not([disabled]){background:var(--color-danger-soft)}}.icon{display:inline-flex;width:16px;height:16px;svg{width:100%;height:100%}}&.lg .icon{width:18px;height:18px}.spinner{width:14px;height:14px;border:2px solid currentColor;border-right-color:transparent;border-radius:var(--radius-full);animation:ui-button-spin 0.7s linear infinite}@keyframes ui-button-spin{to{transform:rotate(360deg)}}
}`
};
}

Fez('ui-button', __fez_component_0);

export default __fez_component_0;
